import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';

import CardMenu from './CardMenu';
import Label from './Label';
import AnonymousIcon from '../../../AnonymousIcon';

import {
  Main,
  Content,
  Footer,
  Divider,
  Header,
  HiddenBadge,
  RightItems,
  StyledVisibilityOff,
  SubmittedLabel,
  ClickableContent,
  StyledGroupIcon,
  GroupBadge,
  AnonymousBadge,
} from './AssignmentCard.styled';

import formatDate from '../../../../../../core/utils/formatDate';

class AssignmentCard extends PureComponent {
  render() {
    const {
      displayDate,
      isHidden,
      status,
      title,
      startDate,
      dueDate,
      Logo,
      dense,
      menuItems,
      isSubmitted,
      grade,
      onContentClick,
      isGroupAssignment,
      customFooter,
      isAnonymised,
    } = this.props;

    const dateFooter =
      displayDate === 'startDate'
        ? `Open - ${formatDate(startDate)}`
        : `Due - ${formatDate(dueDate)}`;

    const footerText = grade ? `Grade - ${grade}` : customFooter || dateFooter;

    const isClickable = !!onContentClick;

    return (
      <Main isClickable={isClickable} data-testid={`assignment-${title}`}>
        <Header>
          {Logo && <Logo />}
          {status && <Label type={status} />}
          {isSubmitted && (
            <SubmittedLabel>
              <Label type="submitted" />
            </SubmittedLabel>
          )}
          <RightItems>
            {isGroupAssignment && (
              <Tooltip
                title="This is a group assignment"
                position="left"
                enabled
              >
                <GroupBadge>
                  <StyledGroupIcon />
                </GroupBadge>
              </Tooltip>
            )}
            {isHidden && (
              <Tooltip
                title="This assignment is hidden from students"
                position="left"
                enabled
              >
                <HiddenBadge>
                  <StyledVisibilityOff />
                </HiddenBadge>
              </Tooltip>
            )}
            {isAnonymised && (
              <Tooltip
                title="This assignment is anonymised"
                position="left"
                enabled
              >
                <AnonymousBadge>
                  <AnonymousIcon />
                </AnonymousBadge>
              </Tooltip>
            )}
            {menuItems && menuItems.length > 0 && (
              <div>
                <CardMenu
                  title={title}
                  isHidden={isHidden}
                  placement="bottom-end"
                  menuItems={menuItems}
                />
              </div>
            )}
          </RightItems>
        </Header>
        <ClickableContent isClickable={isClickable} onClick={onContentClick}>
          <Content _dense={dense}>{title}</Content>
        </ClickableContent>
        {!dense && <Divider />}
        <Footer _grade={grade} _dense={dense}>
          {footerText}
        </Footer>
      </Main>
    );
  }
}

AssignmentCard.propTypes = {
  Logo: PropTypes.func,
  displayDate: PropTypes.string.isRequired,
  isHidden: PropTypes.bool.isRequired,
  isAnonymised: PropTypes.bool.isRequired,
  dense: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  dueDate: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object),
  isSubmitted: PropTypes.bool,
  grade: PropTypes.string,
  onContentClick: PropTypes.func,
  isGroupAssignment: PropTypes.bool,
  customFooter: PropTypes.string,
};

AssignmentCard.defaultProps = {
  Logo: null,
  menuItems: [],
  isSubmitted: false,
  grade: '',
  onContentClick: undefined,
  isGroupAssignment: false,
  customFooter: undefined,
};

export default AssignmentCard;
